<section class="default-section">
  <article class="default-card">
    <div class="card page-jumbotron-card">
      <div class="page-jumbotron">
        <div class="page-jumbotron-image">
          <picture>
            <img [src]="imgPathRealEstate + 'real-estate-w600.webp'" alt="Immobilien" class="jumbotron-image top-rounded-image" />
          </picture>
        </div>

        <div class="page-jumbotron-content">
          <h1 class="jumbotron-headline">Immobilien</h1>
          <p class="jumbotron-lead">{{ LEAD_REAL_ESTATE }}</p>

          <a [queryParams]="{ categoryId: 'real-estate' }" routerLink="/contact">
            <button color="primary" mat-flat-button>Kontaktieren Sie mich mit Ihrem Angebot!</button>
          </a>
        </div>
      </div>
    </div>

    <h1 class="paragraph-headline">Immobilienstrategie</h1>

    <p>
      Ich kaufe günstige Immobilien in D-Lagen (kleine bis mittelgroße Städte), die häufig renovierungsbedürftig bis unbewohnbar sind. Diese
      renoviere ich dann und schaffe so neuen Wohnraum.
    </p>
    <p>Die Mieteinnahmen nutze ich dabei für folgende Dinge:</p>
    <ol>
      <li>Rückzahlung des Bankdarlehens</li>
      <li>Aufbau von Rücklagen für laufende Instandhaltung und Renovierungen</li>
      <li>Reinvestition in weitere Objekte</li>
    </ol>
    <p></p>
    <p></p>

    <h1 class="paragraph-headline">Wollen Sie ein Objekt verkaufen?</h1>

    <p>
      Wenn Sie eine Wohnung, ein Einfamilienhaus oder ein Mehrfamilienhaus verkaufen möchten,
      <a [queryParams]="{ categoryId: 'real-estate' }" routerLink="/contact">melden Sie sich</a> gern bei mir. Ich bin stets interessiert an
      neuen Objekten - vor allem an solchen, die noch nicht auf den großen Immobilienplattformen gelistet sind.
    </p>

    <h1 class="paragraph-headline">Objekte aus meinem Portfolio</h1>

    @if (imgUrlsObject.length) {
      <div class="mb-3">
        <div class="carousel-container" id="carouselObject">
          <button (click)="previousImage('carouselObject')" aria-label="Vorheriges Bild" class="carousel-button" mat-icon-button>
            <mat-icon>chevron_left</mat-icon>
          </button>
          <div class="carousel-image" (click)="openImage(activeImageIndexObject, imgUrlsObject)">
            @if (getActiveImage("carouselObject"); as activeImageObject) {
              <picture>
                <source [srcset]="activeImageObject.w350" media="(max-width: 350px)" />
                <source [srcset]="activeImageObject.w500" media="(max-width: 500px)" />
                <source [srcset]="activeImageObject.w750" media="(max-width: 750px)" />
                <img [alt]="activeImageObject.title" [src]="activeImageObject.w1124" />
              </picture>
            }
          </div>
          <button (click)="nextImage('carouselObject')" aria-label="Nächstes Bild" class="carousel-button" mat-icon-button>
            <mat-icon>chevron_right</mat-icon>
          </button>
        </div>
        <div class="thumbnail-container m-0 p-0">
          <app-thumbnail-widget (imgClicked)="selectImage($event.index, 'carouselObject')" [imgUrls]="imgUrlsObject"></app-thumbnail-widget>
        </div>
      </div>
    }
  </article>
</section>
